import { useState } from 'react';
import { InformationCircleIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { hasAnyPolicy } from './policyMeta';
import PoliciesDrawer from './PoliciesDrawer';

/**
 * Discreet "Things to know before you book" row for the services step.
 * Opens the shared full-text policies drawer; returns null when the
 * provider has no policies set.
 */
const PoliciesLink = ({ bookingPage, className = '' }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!hasAnyPolicy(bookingPage)) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setDrawerOpen(true)}
        aria-haspopup="dialog"
        className={`w-full flex items-center gap-3 border border-themed rounded-card bg-themed-card px-4 py-3 text-left hover-themed-tint focus-themed-ring ${className}`}
      >
        <InformationCircleIcon className="h-5 w-5 text-themed-secondary flex-shrink-0" aria-hidden="true" />
        <span className="text-sm font-medium text-themed-primary flex-1">
          Things to know before you book
        </span>
        <ChevronRightIcon className="h-4 w-4 text-themed-secondary flex-shrink-0" aria-hidden="true" />
      </button>
      <PoliciesDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        bookingPage={bookingPage}
      />
    </>
  );
};

export default PoliciesLink;
